import type { APIInstance } from "./apiService";
import type {
  ChatConversation,
  ChatConversationWithMessages,
  ChatConversationsListResponse,
} from "./caseChatServiceV2.types";

export class CaseChatServiceV2 {
  private api: APIInstance;
  constructor(api: APIInstance) {
    this.api = api;
  }

  async createConversation(caseId: string): Promise<ChatConversation> {
    const response = await this.api.post<ChatConversation>(`/cases/${caseId}/chat/conversations`);
    return response.data;
  }

  async listConversations(caseId: string): Promise<ChatConversation[]> {
    const response = await this.api.get<ChatConversationsListResponse>(
      `/cases/${caseId}/chat/conversations`
    );
    return response.data.conversations;
  }

  async getConversation(
    caseId: string,
    conversationId: string
  ): Promise<ChatConversationWithMessages> {
    const response = await this.api.get<ChatConversationWithMessages>(
      `/cases/${caseId}/chat/conversations/${conversationId}`
    );
    return response.data;
  }
}
